import React, {useState} from 'react';
import styled from "styled-components";
import useZibi from "../../zibi/UseZibi";
import {colors} from "../../maps/colors";
import Edges from "./site/Edges";
import Fields from "./site/Fields";
import Cameras from "./site/Cameras";
import {getQueryValue} from "../../domain/queryHandler";
import {useLocation, useNavigate} from "react-router-dom";

const WrapperStyled = styled.div`
    padding: 20px;
`;

const SiteSettingsStyled = styled.div`
    padding-bottom: 10px;
        //border-bottom: 1px solid ${colors.GRAY1};
    display: grid;
    grid-template-columns: auto 1fr;
    grid-gap: 30px;
    align-items: baseline;

    h1 {
        font-size: 20px;
        padding: 0;
        margin: 0;
    }

    div {
        font-size: 14px;
    }
`;

const DataStyled = styled.div`

`;

const DataWrapperStyled = styled.div`
    background: rgb(231, 235, 240);
    width: 100%;
    display: grid;
    grid-gap: 15px;
    padding: 10px;
    border-radius: 8px;

    h3 {
        padding: 0 0 5px 0;
        margin: 0;
        cursor: pointer;
    }

    .poiklop {
        position: relative;

        &:after {
            position: absolute;
            content: "";
            border: solid black;
            border-width: 0 3px 3px 0;
            display: inline-block;
            padding: 3px;
            transform: rotate(-45deg);
            top: 8px;
            margin-left: 10px;
        }
    }

    .show {
        &:after {
            transform: rotate(45deg);
        }
    }
`;

const SiteData = ({clientId, siteId}) => {
    const history = useNavigate();
    const location = useLocation();

    const edgeId = getQueryValue(location, 'edge');

    const [clients, set_clients] = useZibi('clients');
    const [sitesByClientId, set_sitesByClientId] = useZibi('sitesByClientId');

    const hideEdges = localStorage.getItem("hideEdges") || false;
    const hideFields = localStorage.getItem("hideFields") || false;
    const hideCameras = localStorage.getItem("hideCameras") || false;

    const [showEdges, s_showEdges] = useState(!hideEdges);
    const [showFields, s_showFields] = useState(!hideFields);
    const [showCameras, s_showCameras] = useState(!hideCameras);

    const sites = sitesByClientId?.[clientId] || [];
    const site = sites.find(cl => cl._id === siteId);

    return (
        <WrapperStyled>
            {site && (
                <DataStyled>
                    <SiteSettingsStyled>
                        <h1>{site.name}</h1>
                        <div>
                            SMU IP: {site.smuIp || ""}
                        </div>
                    </SiteSettingsStyled>
                    <DataWrapperStyled>
                        <h3
                            className={`poiklop ${showEdges ? "show" : ""}`}
                            onClick={() => {
                                s_showEdges(!showEdges);
                                if (showEdges) {
                                    localStorage.setItem("hideEdges", "1");
                                } else {
                                    localStorage.removeItem("hideEdges");
                                }
                            }}
                        >
                            Edges
                        </h3>
                        {showEdges && (
                            <Edges/>
                        )}
                        <h3
                            className={`poiklop ${showFields ? "show" : ""}`}
                            onClick={() => {
                                s_showFields(!showFields);
                                if (showFields) {
                                    localStorage.setItem("hideFields", "1");
                                } else {
                                    localStorage.removeItem("hideFields");
                                }
                            }}
                        >
                            Fields
                        </h3>
                        {showFields && (<Fields/>)}

                        <h3
                            className={`poiklop ${showCameras ? "show" : ""}`}
                            onClick={() => {
                                s_showCameras(!showCameras);
                                if (showCameras) {
                                    localStorage.setItem("hideCameras", "1");
                                } else {
                                    localStorage.removeItem("hideCameras");
                                }
                            }}
                        >
                            Cameras
                        </h3>
                        {showCameras && (<Cameras/>)}
                    </DataWrapperStyled>
                </DataStyled>
            )}
        </WrapperStyled>
    );
};

export default SiteData;